import React from 'react';

import Dropdown from '../../../Inputs/Dropdown';

const BonusPeriodSelector = ({
  options,
  selectedLabel,
  onDatePickerOpen,
  onDatePickerClose,
}: {
  options: { id: string; label: string; onSelected: () => void }[];
  selectedLabel: string;
  onDatePickerOpen?: () => void;
  onDatePickerClose?: () => void;
}) => (
  <Dropdown
    onOpen={onDatePickerOpen}
    onClose={onDatePickerClose}
    selectedLabel={selectedLabel}
    options={options}
  />
);

export default BonusPeriodSelector;
